import { Button, Grid, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import React from 'react';
import { newsDetails } from '../../../Actions/News';
import { v4 as uuidv4 } from 'uuid';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchNewsData } from '../../../Actions/News';
import CloseIcon from '@mui/icons-material/Delete';
import { newsDelete } from '../../../Actions/News';
import NewseditorCard from './NewseditorCard';
import { NEWS_REQUEST, NEWS_SUCCESS, NEWS_FAILURE,NEWS_DELETE } from '../../../Constants/ActionTypes';
 import { toast } from "react-toastify";
import * as API from '../../../API/api';
import axios from 'axios';
const NewsEditorForm = () => {
  const dispatch = useDispatch();

  const [newsInfo, setNewsInfo] = useState([]);

  // const newsdata = useSelector(state => state.newsData);

  // useEffect(() => {
  //   dispatch(fetchNewsData());
  // }, [dispatch]);

  // useEffect(() => {
  //   newsdata.newsData.data && setNewsInfo(newsdata.newsData.data);
  // }, [newsdata]);




  // const fetchNewsData = (token) => async dispatch => {
  //   try {
  //     dispatch({ type: NEWS_REQUEST });
  //     const { data } = await API.fetchNews(token);
  //     if (data) {
  //       dispatch({ type: NEWS_SUCCESS, payload: data });
  //       setNewsInfo(data);
  //     }
  //     else if(data.length === 0){
  //       console.log("no news");
  //     }
  //   } catch (error) {
  //     toast('ERROR IN FETCHING NEWS');
  //   console.log(error)
  //   dispatch({ type: NEWS_FAILURE });
  //   }
  // };

  
  const getData = async () => {
    axios
      .get(API.getNews)
      .then(response => {
        setNewsInfo(response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  };

  useEffect(() => {
   
      getData();
    
   
  }, []);






  // console.log(newsInfo, 'newsInfo');

  const deleteHandler = id => {

    dispatch(newsDelete({code: id}, userData.token));
    getData();

  };

  const validate = Yup.object().shape({
    title: Yup.string().required('Required'),
    startDate: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
  });
  const userData = JSON.parse(localStorage.getItem('access_token'));

  const formik = useFormik({
    initialValues: {
      title: '',
      startDate: '',
      description: '',
    },
    validationSchema: validate,
    onSubmit: (values, onSubmitProps) => {
      dispatch(
        newsDetails(
          {
            code: uuidv4(),
            title: values.title,
            description: values.description,
          },
          userData.token,
        ),
      );

      // setOpen(true);
      onSubmitProps.resetForm();
getData();    },
  });

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <form  onSubmit={formik.handleSubmit}>
        <Grid
          Container
          sx={{
            marginTop: 5,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <Typography variant="h5" sx={{ fontFamily: 'Sora', color: 'black', fontWeight: 'bold' }}>
              Enter Your News
            </Typography>
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            marginTop: 6,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              id="title"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              error={formik.touched.title && Boolean(formik.errors.title)}
              helperText={formik.touched.title && formik.errors.title}
              variant="standard"
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your News Heading"
              size="small"
              sx={{
                width: '300px',
                p: 1,
                borderRadius: 2,
                backgroundColor: 'white',
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
              }}
            />
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              id="startDate"
              name="startDate"
              value={formik.values.startDate}
              onChange={formik.handleChange}
              error={formik.touched.startDate && Boolean(formik.errors.startDate)}
              helperText={formik.touched.startDate && formik.errors.startDate}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              type="date"
              sx={{ width: 220 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            my: 1,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
        >
          <Grid item md={6} sm={12} xs={12} sx={{ marginTop: '10px' }}>
            <Typography sx={{ fontFamily: 'Sora', opacity: 0.3, fontSize: '14px', my: 1, fontWeight: 'bold' }}>
              Enter Your News Description*
            </Typography>
            <TextField
              id="description"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              error={formik.touched.description && Boolean(formik.errors.description)}
              helperText={formik.touched.description && formik.errors.description}
              variant="standard"
              size="small"
              sx={{
                width: '70%',
                borderRadius: 2,
                backgroundColor: 'white',
                p: 1,

                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
                height: '100px',
              }}
              multiline="true"
              maxRows="4"
              minRows="2"
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
            />
          </Grid>
        </Grid>

        <Grid
          Container
          sx={{
            marginTop: 2,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12}>
            <Button
              variant="outlined"
              sx={{
                backgroundColor: '#FF7345',
                color: 'white',
                border: 0,
                width: '200px',
                fontFamily: 'Sora',
                '&:hover': {
                  border: 0,
                  backgroundColor: '#d95429',
                },
              }}
              type="submit"
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
      <br></br>
      <br></br>

      <div style={{ background: 'none' }}>
        {newsInfo.map((data) => (
          <div
            style={{
              width: '30%',
              // height: '150px',
              boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
              margin: '10px ',
              float: 'left',
              padding: '10px',
            }}
          >
            <div style={{ textAlign: 'end', color: '#FF7345' }}>
              {' '}
              <button onClick={() => deleteHandler(data.code)} style={{ border: 'none', background: 'none' }}>
                <CloseIcon style={{ color: '#f5363c' }}></CloseIcon>
              </button>
            </div>
            <div
              style={{ color: 'black', fontFamily: 'Sora', margin: '2px 10px', fontWeight: 'bold', fontSize: '18px' }}
            >
              {data.title}
            </div>
            <div style={{ fontFamily: 'Sora', fontSize: '16px', margin: '0 10px' }}>{data.description}</div>
          </div>
        ))}
      </div>
{/* 
     { newsInfo.map(data=>{
           <NewseditorCard title={data.title} description={data.description} code={data.code}></NewseditorCard>
     })} */}
      <br></br>
      <br></br>
    </div>
  );
};

export default NewsEditorForm;
